import React from "react";
import { Button, Space } from "antd";
import {
  RiCheckboxCircleLine,
  RiCloseCircleLine,
  RiSortAsc,
  RiDeleteBin2Line,
} from "react-icons/ri";

const BatchActionBar = ({
  selectedUnplacedCount,
  selectedPlacedCount,
  onSelectAll,
  onDeselectAll,
  onBatchPlace,
  onOpenReorder,
  onBatchRemove,
}) => {
  const totalCount = selectedUnplacedCount + selectedPlacedCount;
  const hasUnplaced = selectedUnplacedCount > 0;
  const hasPlaced = selectedPlacedCount > 0;
  const isMixed = hasUnplaced && hasPlaced;

  return (
    <div
      style={{
        padding: "10px 12px",
        backgroundColor: "#e6f7ff",
        border: "1px solid #91d5ff",
        borderRadius: 6,
        marginBottom: 12,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <span style={{ fontWeight: 500, color: "#0050b3", fontSize: 13 }}>
          已選: {totalCount} 個
        </span>
        <Space size={4}>
          <Button
            size="small"
            icon={<RiCheckboxCircleLine />}
            onClick={onSelectAll}
            style={{ fontSize: 12 }}
          >
            全選
          </Button>
          <Button
            size="small"
            icon={<RiCloseCircleLine />}
            onClick={onDeselectAll}
            style={{ fontSize: 12 }}
          >
            取消
          </Button>
        </Space>
      </div>

      {hasUnplaced && (
        <div
          style={{
            marginBottom: hasPlaced ? 6 : 0,
          }}
        >
          {isMixed && (
            <div
              style={{
                fontSize: 11,
                color: "#0050b3",
                marginBottom: 4,
                fontWeight: 500,
              }}
            >
              未放置操作 ({selectedUnplacedCount}):
            </div>
          )}
          <div style={{ display: "flex", gap: 6 }}>
            <Button
              size="small"
              icon={<RiSortAsc />}
              onClick={onOpenReorder}
              disabled={selectedUnplacedCount < 2}
              style={{ flex: 1, fontSize: 12 }}
            >
              排序
            </Button>
            <Button
              type="primary"
              size="small"
              onClick={onBatchPlace}
              style={{ flex: 1, fontSize: 12 }}
            >
              放置
            </Button>
          </div>
        </div>
      )}

      {hasPlaced && (
        <div>
          {isMixed && (
            <div
              style={{
                fontSize: 11,
                color: "#0050b3",
                marginBottom: 4,
                fontWeight: 500,
              }}
            >
              已放置操作 ({selectedPlacedCount}):
            </div>
          )}
          <div style={{ display: "flex", gap: 6 }}>
            <Button
              danger
              size="small"
              icon={<RiDeleteBin2Line />}
              onClick={onBatchRemove}
              style={{ flex: 1, fontSize: 12 }}
            >
              移除
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BatchActionBar;

